import { AfterViewInit, Directive, ElementRef, Input } from '@angular/core';
import { distinctUntilChanged, fromEvent, throttleTime } from 'rxjs';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Directive({
  selector: '[appMorphingButton]',
})
export class MorphingButtonDirective implements AfterViewInit {
  //#region Inputs

  @Input({ required: true }) isEnabled: boolean;
  @Input({ required: true }) scrollableSelector: string;

  //#endregion

  private buttonElement: HTMLElement;
  private labelElement: HTMLElement;
  private scrollableElement: HTMLElement;

  constructor(private hostElement: ElementRef) {}

  //#region Lifecycle hooks

  ngAfterViewInit(): void {
    if (!this.isEnabled) {
      return;
    }

    if (!this.scrollableSelector) {
      throw new Error('Scrollable element selector was not provided!');
    }

    this.buttonElement = this.hostElement.nativeElement as HTMLElement;
    this.labelElement = this.buttonElement.querySelector<HTMLElement>('.label');

    if (!this.labelElement) {
      throw new Error('The button text element must have ".label" class!');
    }

    this.scrollableElement = document.body.querySelector(
      this.scrollableSelector
    );

    this.init();
  }

  //#endregion

  //#region Private methods

  private init(): void {
    let prevScrollPos = this.scrollableElement.scrollTop;

    fromEvent(this.scrollableElement, 'scroll')
      .pipe(untilDestroyed(this), throttleTime(100), distinctUntilChanged())
      .subscribe(() => {
        const currentScrollPos = this.scrollableElement.scrollTop;

        this.buttonElement.classList.toggle(
          'collapsed',
          prevScrollPos < currentScrollPos
        );
        prevScrollPos = currentScrollPos;
      });
  }

  //#endregion
}
